export const FOREGROUND_REFRESH_DEBOUNCE_MS = 1_000;

export function shouldRefreshOnForeground(
  visibilityState: DocumentVisibilityState,
  lastRefreshAt: number,
  now: number,
) {
  return visibilityState === 'visible' && now - lastRefreshAt >= FOREGROUND_REFRESH_DEBOUNCE_MS;
}
